
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndWarranty/create",
      function () {
        return require("private-next-pages/remyndWarranty/create.tsx");
      }
    ]);
  